<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paiming">
      成本控制
    </div>
    <div class="paiming2">
      <div class="ms">
        办理建筑许可成本约为180元，处于对标城市的中上水平，排名第2位;对标城市中企业开办成本最低为上海合计100元，相差30元左右
      </div>
      <div class="head">
        <div class="item1">排名</div>
        <div class="item2">城市</div>
        <div class="item3">得分</div>
      </div>
      <div class="body">
        <div class="bodyitem" v-for="(item,index) in list" :key="index">
          <div class="item1">{{ index + 1 }}</div>
          <div class="item2">{{ item.title }}</div>
          <div class="item3">{{ item.fenshu }}分</div>
        </div>
      </div>
      <div class="chengben2">
        <div class="chengben3">
          <chengben :list="list"></chengben>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chengben from "@/components/chengben";

export default {
  components: {chengben},
  name: "paiming",
  data: function () {
    return {
      list: [{
        title: '上海',
        fenshu: 90,
        danwei: '分',
      }, {
        title: '大连',
        fenshu: 80,
        danwei: '分',
      }, {
        title: '北京',
        fenshu: 80,
        danwei: '分',
      }, {
        title: '深圳',
        fenshu: 80,
        danwei: '分',
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 50px;

}

.paiming2 {
  width: 700px;
  height: 971px;
  background: url("../../assets/kuangjialeft.png") left top no-repeat,
  url("../../assets/kuangjiabottom.png") right bottom no-repeat,
  rgba(35, 77, 205, 0.16);
  padding-top: 40px;

  .head {
    width: 642px;
    height: 60px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  width: 642px;
  margin: auto;
}

.bodyitem {
  height: 84px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.ms {
  width: 642px;
  height: 95px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin: 0px auto 20px;
}
.chengben2{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  .chengben3{
    margin-left: -60px;
  }
}
</style>
